import React, { useState } from 'react'
import { Badge, Box, Button, Checkbox, Drawer, FormControl, Grid, IconButton, MenuItem, Pagination, PaginationItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, } from '@mui/material'
import searchicon from '../../assets/Images/Businesses/Search-Normal.png'
import charticon from '../../assets/Images/Businesses/Chart-Normal.png'
import uploadicon from '../../assets/Images/Businesses/Upload-Normal.png'
import { CancelOutlined, DeleteOutline, KeyboardArrowLeft, KeyboardArrowRight, MoreHoriz } from '@mui/icons-material'
import { Field, Form, Formik, useFormik } from 'formik'
import * as Yup from "yup";


const data = [
  {
    "business": "McDonalds",
    "id": "#92754",
    "type": "Restaurant",
    "regNo": "REG-0128790",
    "contactPerson": "Jack Thompson",
    "number": "(+61) 432 207 900",
    "email": "johnmcclane@gmail.com",
    "status": "Active"
  }
]

interface BusinessForm {
  businessname: string;
  businesstype: string;
  registrationnumber: string;
  registrationdocument: string;
  businesslogo: string;
}
const Step1 = () => {

  const initialValues: BusinessForm = {
    businessname: "",
    businesstype: "Retail",
    registrationnumber: "",
    registrationdocument: "",
    businesslogo: ""
  };
  const validationSchema = Yup.object({
    businessname: Yup.string().required("Business Name is required"),
    // businesstype: Yup.string().required("Business Type is required"),
    registrationnumber: Yup.string().required("Registration number is required"),
    registrationdocument: Yup.string().required("Registration required"),
    businesslogo: Yup.string().required("Business logo is required"),
  });

  const onSubmit = (values: BusinessForm) => {
  };

  const formik = useFormik<BusinessForm>({
    initialValues,
    onSubmit,
    validationSchema,
    validateOnChange: true,
    validateOnBlur: true,
  })

  return (
    <Box>
      <h4 className='mb-0'>Business Details</h4>

      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({ errors, touched }) => (
          <Form className='my-2' onSubmit={formik.handleSubmit}>
            <FormControl fullWidth className='form mb-4'>
              <label><Typography className='text-main' variant='subtitle2'>Business Name <span style={{ color: 'red' }}>*</span></Typography></label>
              <Field
                as={TextField}
                name='businessname'
                error={Boolean(formik.errors.businessname)}
                helperText={formik.errors.businessname}
              >
              </Field>
            </FormControl>
            <FormControl fullWidth className='form mb-4'>
              <label><Typography className='text-main' variant='subtitle2'>Business Type<span style={{ color: 'red' }}>*</span></Typography></label>
              <Field
                as={Select}
                name='businesstype'
                error={Boolean(formik.errors.businesstype)}
                helperText={formik.errors.businesstype}
              >
                <MenuItem value="" selected>Select Type</MenuItem>
                <MenuItem value="Retail">Retail</MenuItem>
                <MenuItem value="Manufacturing">Manufacturing</MenuItem>
                <MenuItem value="Service">Service</MenuItem>
              </Field>
            </FormControl>
            <FormControl fullWidth className='form mb-4'>
              <label><Typography className='text-main' variant='subtitle2'>Registration Number<span style={{ color: 'red' }}>*</span></Typography></label>
              <Field
                as={TextField}
                name='registrationnumber'
                error={Boolean(formik.errors.registrationnumber)}
                helperText={formik.errors.registrationnumber}
              ></Field>
            </FormControl>
            <FormControl fullWidth className='form mb-4'>
              <label htmlFor='file-upload'><Typography className='text-main' variant='subtitle2'>Registration Document<span style={{ color: 'red' }}>*</span></Typography>
                <Box sx={{ cursor: 'pointer' }} className='p-5 border-20' border='2px dashed #0000002A' position='relative'>
                  <input
                    type="file"
                    id="file-upload"
                    className='border'
                    style={{ visibility: 'hidden' }}
                    onChange={(e) => {
                      if (e.target.files && e.target.files[0]) {
                        formik.setFieldValue("registrationdocument", e.target.files[0].name);
                      }
                    }} />
                  <Box className='d-flex flex-column justify-content-center align-items-center' position='absolute' top='50%' left='50%' sx={{ transform: 'translate(-50%,-50%)' }}>
                    <img height='40px' src={uploadicon} alt="" />
                    <Typography className='text-main'>Upload Document</Typography>
                  </Box>
                </Box>
              </label>
              <Typography variant="caption" color="error">
                {formik.errors.registrationdocument}
              </Typography>
            </FormControl>
            <FormControl fullWidth className='form mb-4'>
              <label htmlFor='file-upload2'><Typography className='text-main' variant='subtitle2'>Business Logo<span style={{ color: 'red' }}>*</span></Typography>
                <Box sx={{ cursor: 'pointer' }} className='p-5 border-20' border='2px dashed #0000002A' position='relative'>
                  <input
                    type="file"
                    id="file-upload2"
                    className='border'
                    style={{ visibility: 'hidden' }}
                    onChange={(e) => {
                      if (e.target.files && e.target.files[0]) {
                        formik.setFieldValue("businesslogo", e.target.files[0].name);
                      }
                    }} />
                  <Box className='d-flex flex-column justify-content-center align-items-center' position='absolute' top='50%' left='50%' sx={{ transform: 'translate(-50%,-50%)' }}>
                    <img height='40px' src={uploadicon} alt="" />
                    <Typography className='text-main'>Upload Document</Typography>
                  </Box>
                </Box>
              </label>
              <Typography variant="caption" color="error">
                {formik.errors.businesslogo}
              </Typography>
            </FormControl>
            <Button className='btn-black py-3' type='submit' fullWidth><Typography>Save & Next</Typography></Button>
          </Form>
        )}
      </Formik>
    </Box>
  )
}
function Businesses() {
  const [selected, setSelected] = useState<number[]>([]);
  const [iscreatenew, setiscreatenew] = useState<boolean>(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [searchBusiness, setSearchBusiness] = useState<String>('')
  const totalItems = data.length;

  const totalPages = Math.ceil(totalItems / rowsPerPage);


  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      // select all indexes
      const allIndexes = data.map((_, index) => index);
      setSelected(allIndexes);
    } else {
      setSelected([]);
    }
  };

  const isSelected = (index: number) => selected.indexOf(index) !== -1;

  const handleClick = (index: number) => {
    const selectedIndex = selected.indexOf(index);
    let newSelected: number[] = [];

    if (selectedIndex === -1) {
      newSelected = [...selected, index];
    } else {
      newSelected = selected.filter((item) => item !== index);
    }
    setSelected(newSelected);
  };

  return (
    <Box className='h-100'>
      {/* ------------------------------------------------------------ Top Actions ----------------------------------------------- */}
      <Box className='d-flex input align-items-center justify-content-between'>
        <TextField className='border-10' value={searchBusiness} onChange={(e: React.ChangeEvent<HTMLInputElement>) => { setSearchBusiness(e.target.value) }} sx={{ backgroundColor: 'white', padding: '0px' }} placeholder='Search By Name or ID' slotProps={{ input: { startAdornment: <Box component='img' className='me-3' height='24px' src={searchicon}></Box> } }}></TextField>
        <Box className='d-flex gap-3 align-items-center'>
          <Badge badgeContent={67} className='badge right-10'><Button className='bg-white p-2' sx={{ minWidth: '24px', borderRadius: '10px' }}><img height='24px' className='p-0 m-0' src={charticon} alt="" /></Button></Badge>
          <Button className='btn-black p-2 px-3' onClick={() => { setiscreatenew(true) }}>+ Create New</Button>
        </Box>
      </Box>

      {/* ------------------------------------------------------------ Main Table ----------------------------------------------- */}
      <Paper className='bg-white mt-3 border-20' sx={{ borderRadius: 3, overflow: 'hidden', height: 'calc(100vh - 100px - 65px)', position: 'relative' }}>
        <TableContainer sx={{ height: 'calc(100vh - 100px - 65px - 70px)' }} >
          <Table className='h-100' stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>
                  <Checkbox
                    indeterminate={
                      selected.length > 0 && selected.length < data.length
                    }
                    checked={
                      data.length > 0 && selected.length === data.length
                    }
                    onChange={(e: any) => { handleSelectAllClick(e) }} /></TableCell>
                <TableCell>Business</TableCell>
                <TableCell>ID</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Reg. No.</TableCell>
                <TableCell>Contact Person</TableCell>
                <TableCell>Number</TableCell>
                <TableCell>Email ID</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody sx={{ border: '2px solid red', height: 'calc(100% - 52px - 52px - 60px)', overflow: "auto" }}>
              {data
                .filter(item => searchBusiness === "" || item.business.toLowerCase().includes(searchBusiness.toLowerCase()))
                .map((item, index) => {
                  const isItemSelected = isSelected(index);
                  return (
                    <TableRow
                      hover
                      key={index}
                      onClick={() => handleClick(index)}
                      selected={isItemSelected}
                      role="checkbox"
                      aria-checked={isItemSelected}
                    >
                      <TableCell><Checkbox checked={isItemSelected} /></TableCell>
                      <TableCell>{item?.business}</TableCell>
                      <TableCell>{item?.id}</TableCell>
                      <TableCell>{item?.type}</TableCell>
                      <TableCell>{item?.regNo}</TableCell>
                      <TableCell>{item?.contactPerson}</TableCell>
                      <TableCell>{item?.number}</TableCell>
                      <TableCell>{item?.email}</TableCell>
                      <TableCell><Button className={item?.status === "Active" ? 'btn-success' : 'btn-danger'}>{item?.status}</Button></TableCell>
                      <TableCell><MoreHoriz /></TableCell>
                    </TableRow>
                  )
                })}

            </TableBody>
          </Table>
        </TableContainer>

        <Box
          className='pagination'
          display="flex"
          borderTop='1px solid #ccc'
          alignItems="center"
          justifyContent="space-between"
          sx={{ padding: "20px 16px", backgroundColor: "#fff" }}
        >
          {/* Left side: Results info */}
          <Typography variant="body2">
            Showing Results {Math.min((page - 1) * rowsPerPage + rowsPerPage, totalItems)} of {totalItems}
          </Typography>

          {/* Middle: Pagination */}
          <Pagination
            count={totalPages}
            page={page}
            onChange={(e, value) => setPage(value)}
            renderItem={(item) => (
              <PaginationItem
                {...item}
                slots={{
                  previous: () => <Box className='d-flex align-items-center gap-2'><KeyboardArrowLeft /><Typography className='border-bottom' variant="body2">Previous</Typography></Box>,
                  next: () => <Box className='d-flex align-items-center gap-2'><Typography className='border-bottom' variant="body2">Next</Typography><KeyboardArrowRight /></Box>,
                }}
                sx={{
                  "&.Mui-selected": {
                    backgroundColor: "black",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "#333", // Slightly lighter on hover
                    },
                  },
                }}
              />
            )}
          />

          {/* Right side: Items per page */}
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="body2">Items per Page:</Typography>
            <Select
              size="small"
              value={rowsPerPage}
              onChange={(e) => setRowsPerPage(Number(e.target.value))}
              sx={{ height: "32px", bgcolor: '#0000005A' }}
            >
              {[10, 25, 50, 100].map((num) => (
                <MenuItem key={num} value={num}>
                  {num}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </Box>
        <Box className={`action-bar d-flex align-items-center border bg-light-main p-2 border-10 ${selected.length > 0 ? "showselected" : ""
          }`} gap={2} position='absolute' sx={{ bottom: '70px', left: '35%', transform: 'translate(0%,-50%)' }} zIndex='2'>
          <Box className='d-flex align-items-center text-light border-10 border-light p-2' gap={2}>
            <Typography>{selected.length} Selected</Typography>
            <CancelOutlined />
          </Box>
          <Button onClick={() => { setSelected([]) }} sx={{ borderRadius: '10px' }} className='d-flex bg-danger align-items-center text-light transform p-2 gap-2'>
            <DeleteOutline sx={{ color: 'white' }} />
            <Typography>Delete Selected</Typography>
          </Button>
        </Box>
      </Paper>

      {/* ------------------------------------------------------------ Create Business ----------------------------------------------- */}
      <Drawer anchor={'right'} onClose={() => setiscreatenew(false)}
        PaperProps={{
          sx: {
            width: '30%',
          },
        }} open={iscreatenew}>
        <Box>
          <Box className='d-flex p-3 border-bottom align-items-center justify-content-between'>
            <h2 className='mb-0'>Create Business</h2>
            <IconButton onClick={() => { setiscreatenew(false) }}><CancelOutlined></CancelOutlined></IconButton>
          </Box>
          <Box className='px-3 py-2'>
            <Grid spacing={2} container>
              <Grid size={6} height='5px' className='bg-main border-10'></Grid>
              <Grid size={6} height='5px' className='bg-main border-10'></Grid>
            </Grid>
            <Box className='my-3'>
              <Step1 />
            </Box>
          </Box>
        </Box>
      </Drawer>

    </Box>
  )
}

export default Businesses
